import type { TaxInvoiceKind, TaxInvoiceStatus } from '@repo/api-contracts';

export const TAX_INVOICE_STATUS_LABELS: Record<TaxInvoiceStatus, string> = {
  PENDING: '발행 대기',
  ISSUED: '발행 완료',
  FAILED: '실패',
  VOID: '무효',
};
export const TAX_INVOICE_KIND_LABELS: Record<TaxInvoiceKind, string> = {
  ISSUE: '발행',
  CANCEL: '취소',
};
